module.exports = __webpack_public_path__ + "img/forbes.bff314fd.png";